

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { User } from './../../../_models/user';
import { AuthService } from './../../../_services/auth.service';
import { UserService } from './../../../_services/user.service';

@Component({
  selector: 'app-register-step-one-email',
  templateUrl: './register-step-one-email.component.html',
  styleUrls: ['./register-step-one-email.component.css']
})
export class RegisterStepOneEmailComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  responseMessage = '';
  errorEncountered=false

  isRegistrationSuccess=false
  roles: string[] = [];
  user:User=new User()
  registeredUser=new User()
  userMessage=""

  constructor(
      private formBuilder: FormBuilder,
      private router: Router,
      private authService: AuthService,
      private userService:UserService

  ) {




  }

  ngOnInit() {
    this.userService.userMessage.subscribe(
      x=>{
        this.userMessage=x
      }
    )
      this.form = this.formBuilder.group({
       username: ['', Validators.compose([Validators.required, Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'), Validators.minLength(1)])],
      });

      this.userService.registrationData.next(new User())


  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(): void {
    this.userService.userMessage.next("")
     let gp = this.authService.gatePass.getValue()
      if (gp.is_logged_in) {
          this.authService.logout()
        }
      this.user.username=this.form.value.username



        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.errorEncountered=false
        this.userService.registrationData.next(this.user)
        this.router.navigate(["/user/new/step/two"])

  }


  reloadPage(): void {
    window.location.reload();
  }


}
